import NestedForm from '/node_modules/stimulus-rails-nested-form/dist/stimulus-rails-nested-form.umd.js'
import axios from "axios";
import notify from "../../packs/notify";
import TestScheduleListManage from "../../packs/test_schedule_list_manage";
import LoadingSpinner from "../../packs/loading_spinner";
import i18next from 'i18next';
import {
  getPredefinedTestResultDefinitionsCount, hideTab, refreshTabs, showTab
} from "./helpers/stepwizard_helper";

let testScheduleList = []

const autoCompleteHiddenSelector = "[data-portal--submission-test-target='autoCompleteHidden']"
const autoCompleteInputSelector = "[data-portal--submission-test-target='autoCompleteInput']"
const msHiddenSelector = "[data-portal--submission-test-target='msHidden']"
const specimenSelector = "[data-portal--submission-test-target='specimen']"
const accessionCommentSelector = "[data-portal--submission-test-target='accessionComment']"
const testInfoContentSelector = "[data-portal--submission-test-target='testInfoContent']"
const msSpecimenSelector = "[data-portal--submission-test-target='multiselect']"


export default class extends NestedForm {

  static targets = [
    "testCard",
    "childIndex",
    "msHidden",
    "autoCompleteHidden",
    "stsIds",
    "testInfoContent",
    "allTestSchedule",
    "showAllTSInTheList",
    "autoCompleteInput",
    "addTest",
    "specimen",
    "accessionCommentContent",
    "accessionComment",
  ]

  static values = {
    recordSize: { type: Number, default: 0 },
    addEventCounter: { type: Number, default: 0 },
    accessionId: String,
    animalId: String,
    accessionLabId: Number,
    accessionComment: String
  };

  connect() {
    super.wrapperSelectorValue = '.nested-form-test-wrapper'
    super.connect()
    this.boundAddTestSchedule = this.addTestSchedule.bind(this)
    this.boundRemoveTestSchedule = this.removeTestSchedule.bind(this)
    this.boundChangeAutoComplete = this.changeAutoComplete.bind(this)
    this.boundRemoveItemFromAutoComplete = this.removeItemFromAutoComplete.bind(this)
    this.boundFindingMultipleRecord = this.findingMultipleRecord.bind(this)

    document.addEventListener("multiselect:triggerMultiselectAddEvent", this.boundAddTestSchedule)
    document.addEventListener("multiselect:triggerMultiselectRemoveEvent", this.boundRemoveTestSchedule)
    document.addEventListener("autocomplete:triggerAutocompleteChangeEvent", this.boundChangeAutoComplete)
    document.addEventListener("autocomplete:removeItemFromAutoCompleteData", this.boundRemoveItemFromAutoComplete)
    document.addEventListener("multiselect:triggerMultiselectHasAlreadyRecord", this.boundFindingMultipleRecord)

    testScheduleList = TestScheduleListManage(this.stsIdsTargets, "initial", "")
    this.checkInitalAllTSInTheListTarget()
    this.checkAccessionLab()
    if (this.hasTestCardTarget && !this.testCardTargets.length) this.addTestTarget.click()
    this.toggleSpecimenTargetInitial()
    this.initialTestLoading()
  }

  disconnect() {
    testScheduleList = []
    testScheduleList.length = 0
    TestScheduleListManage("", "removeMainList", "")
    document.removeEventListener("multiselect:triggerMultiselectAddEvent", this.boundAddTestSchedule)
    document.removeEventListener("multiselect:triggerMultiselectRemoveEvent", this.boundRemoveTestSchedule)
    document.removeEventListener("autocomplete:triggerAutocompleteChangeEvent", this.boundChangeAutoComplete)
    document.removeEventListener("autocomplete:removeItemFromAutoCompleteData", this.boundRemoveItemFromAutoComplete)
    document.removeEventListener("multiselect:triggerMultiselectHasAlreadyRecord", this.boundFindingMultipleRecord)
  }

  autoCompleteHiddenTargetConnected(element) {
    element.addEventListener('change', () => this.handleOrderedTestsChange())
  }

  autoCompleteHiddenTargetDisconnected(element) {
    element.removeEventListener('change', () => this.handleOrderedTestsChange())
  }

  handleOrderedTestsChange(){
    let testScheduleIds = this.autoCompleteHiddenTargets.map((target) => target.value);
    testScheduleIds = testScheduleIds.join(',');
    getPredefinedTestResultDefinitionsCount(null, testScheduleIds)
      .then((res) => {
        const nextPartial = document.querySelector('[data-portal--submission-target="form"]').next_partial
        if (res.data.count > 0) {
          nextPartial.value = "/portal/tabs/predefined_test_results_tab"
          showTab('predefined_test_results_tab_id')
        } else {
          hideTab('predefined_test_results_tab_id')
          nextPartial.value = "/portal/tabs/review_tab"
        }
        refreshTabs()
      })
  }

  initialTestLoading(){
    if (this.recordSizeValue === 0 || this.accessionCommentValue){
      this.add(new CustomEvent("add"))
    }
  }

  refreshIndexValue() {
    for (let i = 0; i < this.childIndexTargets.length; i++) {
      const target = this.childIndexTargets[i];
      target.innerHTML = "Test " + (i + 1)
    }
  }

  // https://dev.labs.tracefirst.com/portal/144336/add_test_schedule_to_specimens.json
  addTestSchedule(e, specimenValuesIds = "") {
    let specimenIds = specimenValuesIds ? specimenValuesIds : e.detail.item.value
    specimenIds = TestScheduleListManage(specimenIds, "filter", e)

    LoadingSpinner("show")

    // if we have already selected test in the accession we should give an error. 
    if (TestScheduleListManage(specimenIds, "isExistsTest", e)) {
      let msg = i18next.t('An error occurred when adding the Test Request')
      msg += " " + i18next.t('Seems you have already added these tests')
      notify({
        message: msg,
        status: "error"
      });
      LoadingSpinner("hide")
      return Promise.resolve()
    }

    const testScheduleIdTarget = this.findTargetByQuerySelector(autoCompleteHiddenSelector, e)

    const testScheduleId = testScheduleIdTarget ? testScheduleIdTarget.value : ""
    if (!specimenIds || !testScheduleId || !this.accessionIdValue) {
      console.warn("There is no specimen ID or Test Schedule ID or Accession ID. You might deleted the existing test already or try re-select a Test again!");
      return
    }

    const currentScheduleItems = TestScheduleListManage(specimenIds, "find", e)
    const currentStsIds = currentScheduleItems[0]
    if (currentStsIds && currentStsIds.length > 0) {
      let msg = i18next.t('An error occurred when adding the Test Request')
      msg += " " + i18next.t('Seems you have already added these tests')
      notify({
        message: msg,
        status: "error"
      });
      LoadingSpinner("hide")
      return Promise.resolve()
    }

    const url = "/portal/" + this.accessionIdValue + "/add_test_schedule_to_specimens.json"
    const data = {
      specimen_ids: specimenIds,
      test_schedule_id: testScheduleId,
      id: this.accessionIdValue
    }
    return axios({ method: 'POST', url: url, data: data })
      .then(res => {
        testScheduleList = TestScheduleListManage(res.data, "add", e)
        const selectedCard = e.target.closest(this.wrapperSelectorValue);
        selectedCard.dataset.newRecord = false
        this.availabilityForAnimal(testScheduleId, specimenIds)
        this.toggleDisabledAutoCompleteInput(e, true)
        this.toggleRequiredSpecimen(e, false)
        LoadingSpinner("hide")
      })
      .catch((error) => {
        LoadingSpinner("hide")
        // const msg =  LocaleMessage('errorWhenAddingTestRequest')
        const msg = i18next.t('An error occurred when adding the Test Request')
        notify({
          message: msg + " : " + error,
          status: "error"
        });
      });
  }

  // https://dev.labs.tracefirst.com/portal/delete_specimen_test_schedules.json
  // specimen_ids: 649962
  // specimen_test_schedule_ids[]: 1125532
  async removeTestSchedule(e, specimenIdValues = "") {
    const specimenIds = specimenIdValues ? specimenIdValues : e.detail.id
    const currentScheduleItems = TestScheduleListManage(specimenIds, "find", e)
    if (!currentScheduleItems) {
      console.warn("There is no specimen test schedule. You might deleted the existing test already or try re-select a Test again!");
      return Promise.resolve()
    }

    const currentStsIds = currentScheduleItems[0]
    const currentSelectedObjects = currentScheduleItems[1]
    if (!specimenIds || !currentStsIds) {
      return Promise.resolve()
    }

    const url = "/portal/delete_specimen_test_schedules.json"
    const data = {
      specimen_ids: specimenIds,
      specimen_test_schedule_ids: currentStsIds
    }
    LoadingSpinner("show")
    try {
      const res = await axios({ method: 'POST', url: url, data: data });
      testScheduleList = TestScheduleListManage(currentSelectedObjects, "remove", e);
      LoadingSpinner("hide");
      return res;
    } catch (error) {
      LoadingSpinner("hide");
      // const msg = LocaleMessage('errorWhenDeletingTestRequest')
      const msg = i18next.t('An error occurred when deleting the Test Request');
      notify({
        message: msg + " : " + error,
        status: "error"
      });
    }
  }

  findTargetByQuerySelector(selector, e) {
    const dataId = e.target.dataset.id
    return document.querySelector(`${selector}[data-id="${dataId}"]`)
  }

  add(e) {
    super.add(e)
    let currentInfoTestContent = this.getLastTarget(this.testInfoContentTargets)
    if (currentInfoTestContent) currentInfoTestContent.innerHTML = ""
    this.refreshIndexValue()
    this.toggleForAllTestScheduleView()
  }

  getLastTarget(targets) {
    return targets[targets.length - 1]
  }

  changeAutoComplete(e) {
    const tsID = e.detail.event.detail.value
    if (!tsID) return

    this.fillTestInfoContent(e, this.testInfoTemplate(tsID))
    this.toggleSpecimenTarget(e, false)
    this.toggleRequiredSpecimen(e, true)

    const selectedMSHidden = this.findTargetByQuerySelector(msHiddenSelector, e)
    const specimenIds = selectedMSHidden ? selectedMSHidden.values : ""
    if (!specimenIds || specimenIds.length == 0) return

    this.addTestSchedule(e, specimenIds.toString())
  }

  remove(e){
    const r = e.target.closest(this.wrapperSelectorValue);
    if (r) r.remove();
  }

  deleteTest(e) {
    const selectedCard = e.target.closest(this.wrapperSelectorValue);
    if (selectedCard.dataset.newRecord === 'true') {
      this.remove(e)
      this.toggleForAllTestScheduleView()
      this.refreshIndexValue()
      this.handleOrderedTestsChange()
    } else {
      const selectedMSHidden = this.findTargetByQuerySelector(msHiddenSelector, e)
      const specimenIds = selectedMSHidden ? selectedMSHidden.values : ""
      if (!specimenIds) return

      let deletedTs = this.removeTestSchedule(e, specimenIds.toString())
      if (!deletedTs) {
        this.remove(e)
        this.toggleForAllTestScheduleView()
        this.refreshIndexValue()
        this.handleOrderedTestsChange()
      }
      deletedTs.then(res => {
        this.remove(e)
        this.toggleForAllTestScheduleView()
        this.refreshIndexValue()
        this.handleOrderedTestsChange()
      })
    }
  }

  removeItemFromAutoComplete(e) {
    const selectedMSHidden = this.findTargetByQuerySelector(msHiddenSelector, e)
    const specimenIds = selectedMSHidden ? selectedMSHidden.values : ""

    this.fillTestInfoContent(e, "")
    if (!specimenIds || specimenIds.length == 0) {
      this.toggleSpecimenTarget(e, true)
      this.toggleRequiredSpecimen(e, false)
      return
    }

    this.removeTestSchedule(e, specimenIds.toString())
      .then(res => {
        this.toggleDisabledAutoCompleteInput(e)
        this.toggleSpecimenTarget(e, true)
        this.toggleRequiredSpecimen(e, false)
      })
  }

  fillTestInfoContent(e, data) {
    const currentInfoTestContent = this.findTargetByQuerySelector(testInfoContentSelector, e)
    currentInfoTestContent.innerHTML = data
  }

  testInfoTemplate(tsID) {
    return `<div class="relative" data-controller="popover" data-popover-url-value="/portal/test_info/` + tsID + `.html">
              <span data-action="mouseenter->popover#show mouseleave->popover#hide" style="cursor: pointer;">
                <i class="fa fa-info-circle"></i>
              </span>
            </div>`
  }

  // https://dev.labs.tracefirst.com/test_schedules/check_availability_for_animal?test_schedule_id=4208&animal_id=386556&specimen_id=651504
  availabilityForAnimal(tsId, specimenIds) {
    specimenIds = this.checkSpecimenIDS(specimenIds)
    for (let index = 0; index < specimenIds.length; index++) {
      const specimenId = specimenIds[index]
      this.axiosAvailabilityForAnimal(tsId, specimenId).then(res => {
        if (!res.data) {
          const msg = i18next.t('Requested test does not match species/breed of choosen animal')
          notify({
            message: msg,
            status: "alert"
          })
          return false
        }
      })
    }
  }

  checkSpecimenIDS(specimenIds) {
    try {
      if (Array.isArray(specimenIds)) {
        specimenIds = specimenIds[0].constructor == Array ? specimenIds[0] : specimenIds
      } else {
        if (specimenIds.indexOf(",") > -1) {
          specimenIds = specimenIds.split(",")
        } else {
          specimenIds = [specimenIds]
        }
      }
    } catch (error) {
      console.warn("Error : ", error)
    }
    return specimenIds
  }

  async axiosAvailabilityForAnimal(tsId, specimenId) {
    return axios({
      method: 'GET',
      url: "/test_schedules/check_availability_for_animal.json",
      params: {
        test_schedule_id: tsId,
        specimen_id: specimenId,
      }
    })
      .then(res => {
        return res
      })
      .catch((error) => {
        const msg = i18next.t('An error occurred when matching species/breed of choosen animal')
        notify({
          message: msg + " : " + error,
          status: "error"
        });
      });
  }

  checkInitalAllTSInTheListTarget() {
    if (!this.hasShowAllTSInTheListTarget) return

    let target = this.showAllTSInTheListTarget
    target.hidden = this.recordSizeValue > 0 ? false : true
  }

  toggleForAllTestScheduleView() {
    if (!this.hasShowAllTSInTheListTarget) return

    let target = this.showAllTSInTheListTarget
    target.hidden = this.childIndexTargets.length > 0 ? false : true
  }

  toggleDisabledAutoCompleteInput(e, isAdded = false) {
    const currentACInput = this.findTargetByQuerySelector(autoCompleteInputSelector, e)
    if (isAdded) {
      currentACInput.disabled = true
    } else {
      currentACInput.disabled = currentACInput.disabled ? false : true
    }
  }

  checkAccessionLab() {
    if (!this.accessionLabIdValue) {
      const msg = i18next.t('Available tests are not able to be displayed until a Lab is chosen')
      notify({
        message: msg,
        status: "alert"
      });
    }
  }

  findingMultipleRecord(e) {
    e.detail.dataset.text
    let msg = i18next.t('An error occurred when adding the Test Request')
    msg += " " + i18next.t('Seems you have already added these tests')
    msg += " " + e.detail.dataset.text
    notify({
      message: msg,
      status: "error"
    });
  }

  toggleSpecimenTargetInitial() {
    for (let index = 0; index < this.specimenTargets.length; index++) {
      const specimenTarget = this.specimenTargets[index];
      const testScheduleInput = document.querySelector(`${autoCompleteInputSelector}[data-id="${specimenTarget.dataset.id}"]`)
      specimenTarget.hidden = !testScheduleInput.value
      const commentTarget = document.querySelector(`${accessionCommentSelector}[data-id="${specimenTarget.dataset.id}"]`)
      if (commentTarget) {
        commentTarget.value = testScheduleInput.value !== "" ? "" : commentTarget.value
        const secondParentNode = commentTarget.parentNode.parentNode
        if (secondParentNode) secondParentNode.hidden = testScheduleInput.value !== ""
      }
    }
  }

  toggleSpecimenTarget(e, toggle) {
    const commentTarget = this.findTargetByQuerySelector(accessionCommentSelector, e)
    if (commentTarget) {
      commentTarget.value = !toggle ? "" : commentTarget.value
      const secondParentNode = commentTarget.parentNode.parentNode
      if (secondParentNode) secondParentNode.hidden = !toggle
    }
    const specimenTarget = this.findTargetByQuerySelector(specimenSelector, e)
    if (specimenTarget) specimenTarget.hidden = toggle
  }

  toggleRequiredSpecimen(e, toggle){
    const msInput = this.findTargetByQuerySelector(msSpecimenSelector, e)
    const msSearchInput = msInput.querySelector(".multiselect__search")
    if (msSearchInput) msSearchInput.required = toggle
  }

}